import Avatar from '@asphalt-react/avatar';
import Button from '@asphalt-react/button';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import * as flags from 'round-flags';
import routes from '../../common/models/route-constants';
import LoadingPage from '../../common/pages/LoadingPage';
import { getIllustrationRegions } from '../api/regionsApi';
import Flag from '@asphalt-react/flag';
import Permission from '../../authorization/components/Permission';
import actions from '../../authorization/models/actions';
import styles from './RegionsPage.module.css';

function RegionsPage() {
    let { path } = useRouteMatch();
    let history = useHistory();
    const location = useLocation();

    const [regions, setRegions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [notification, setNotification] = useState(null);

    const clearHistoryNotificationState = (history) => {
        let state = { ...history.location.state };
        delete state.notification;
        history.replace({
            ...history.location,
            state,
        });
    };

    function getRegionListItem(regionId, regionName, regionIdentifier) {
        return (
            <div key={regionId} className={styles.regionItemContainer}>
                <div className={styles.flagContainer}>
                    <Avatar size='xs'>
                        <img
                            src={flags[regionIdentifier]}
                            alt={`${regionName} flag`}
                            aria-label={`${regionName} flag`}
                        />
                    </Avatar>
                </div>
                <p className={styles.bodyMediumText}>
                    {_.startCase(regionName)}
                </p>
            </div>
        );
    }

    useEffect(() => {
        getIllustrationRegions()
            .then((regions) => {
                setRegions(regions.docs);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error(error);
            });
        if (location.state && location['state'].notification) {
            setNotification(location.state.notification);
        }
    }, [setRegions, location]);

    return (
        <React.Fragment>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <React.Fragment>
                    <div className={`panel ${notification ? 'show' : ''}`}>
                        <div
                            className={`animateFlag ${
                                notification ? 'visible' : ''
                            }`}>
                            <Flag
                                success
                                floating
                                title={notification ? notification.title : ''}
                                content={
                                    notification ? notification.content : ''
                                }
                                onDismiss={() => {
                                    setNotification(null);
                                    clearHistoryNotificationState(history);
                                }}
                            />
                        </div>
                    </div>
                    <div className={styles.regionsPageContainer}>
                        <div className={styles.headingAndButtonContainer}>
                            <h3 className={styles.heading}>Regions</h3>
                            <div className={styles.buttonContainer}>
                                <Permission action={actions.CREATE_REGION}>
                                    <Button
                                        onClick={() => {
                                            history.push(
                                                `${path}/${routes.CREATE}`
                                            );
                                        }}>
                                        Add region
                                    </Button>
                                </Permission>
                            </div>
                        </div>
                        <div className={styles.regionListContainer}>
                            {regions.map((regionDoc) =>
                                getRegionListItem(
                                    regionDoc.id,
                                    regionDoc.data().name,
                                    regionDoc.data().identifier
                                )
                            )}
                        </div>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default RegionsPage;
